import i18n from "i18next";
import XHR from "i18next-xhr-backend";
import { reactI18nextModule } from "react-i18next";

i18n
	.use(XHR)
	.use(reactI18nextModule)
	.init({
		lng: "en",
		fallbackLng: "en",
		react: {
			wait: true,
		},
		backend: {
			loadPath: "{{lng}}/{{ns}}",
			parse: data => data,
			// eslint-disable-next-line no-unused-vars
			ajax: (url, options, callback, data) => {
				import(`../services/locales/${url}.json`)
					.then(data => {
						callback(data, { status: "200" });
					})
					.catch(() => {
						callback(null, { status: "404" });
					});
			},
		},
	});

export default i18n;



// WEBPACK FOOTER //
// ./src/utils/i18n.js